import { render, staticRenderFns } from "./ClinicDoctorProfile.vue?vue&type=template&id=21c610ee&scoped=true"
import script from "./ClinicDoctorProfile.vue?vue&type=script&lang=js"
export * from "./ClinicDoctorProfile.vue?vue&type=script&lang=js"
import style0 from "./ClinicDoctorProfile.vue?vue&type=style&index=0&id=21c610ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c610ee",
  null
  
)

export default component.exports